import type { App } from 'vue';
import axios from './axios.js';

const VueAxios = {
    install(app: App) {
        app.config.globalProperties.$axios = axios;
        app.provide('$axios', axios);
    },
};

export default VueAxios;
